import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Input, message} from 'antd'
import {updateDesignOrder} from "../../../../../services/api/3dApi"

const {Search} = Input

const sleep = (ms) => {
    return new Promise(resole => setTimeout(resole, ms))
}

class UpdateDesign extends Component {
    state = {
        loading: false,
    }

    _handleSave = (value, e) => {
        e.preventDefault()

        this._updateDesign(value)
    }

    _updateDesign = async (value) => {
        try {
            this.setState({loading: true})

            await sleep(500)

            const {side, orderId, type, onSuccess} = this.props

            const params = {
                [side]: value,
            }

            const {data: response} = await updateDesignOrder(orderId, type, params)

            const {success, error} = response

            if (!success) {
                throw new Error(error)
            }

            onSuccess()

            message.success(`${side} url updated.`, 1)
        } catch (e) {
            message.error(e.message, 3)
        } finally {
            this.setState({
                loading: false,
            })
        }
    }

    render() {
        const {loading} = this.state

        return (
            <div className='UpdateDesign'>
                <Search type='url' enterButton='Save' onSearch={this._handleSave} defaultValue={this.props.url}
                        loading={loading}/>
            </div>
        )
    }
}

UpdateDesign.defaultProps = {
    url: '',
}

UpdateDesign.propTypes = {
    url: PropTypes.string,
    side: PropTypes.string.isRequired,
    orderId: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['update-design', 'update-mock-up']),
    onSuccess: PropTypes.func,
}

export default UpdateDesign
